var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
var UiButton = /** @class */ (function (_super) {
    __extends(UiButton, _super);
    function UiButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.animationComplete = false;
        return _this;
    }
    UiButton.prototype.handleClick = function (event) {
        this.$emit('click', event);
    };
    UiButton.prototype.ripple = function (event) {
        var _this = this;
        if (this.animationComplete) {
            return;
        }
        if (this.$el.classList.contains('disabled')) {
            return;
        }
        var ripple = document.createElement('div');
        ripple.classList.add('circle');
        ripple.setAttribute('style', "top:" + (event.offsetY - 15) + "px; left:" + (event.offsetX - 15) + "px");
        this.$el.classList.add('btn-ripple-wrap');
        this.$el.appendChild(ripple);
        setTimeout(function () {
            _this.$el.classList.remove('btn-ripple-wrap');
            _this.$el.removeChild(ripple);
            _this.animationComplete = true;
            _this.$nextTick(function () {
                _this.animationComplete = false;
            });
        }, this.rippleDuration);
    };
    UiButton.prototype.render = function (h, ctx) {
        return h(this.tag, {
            class: ['ui-btn'],
            on: {
                mousedown: this.ripple,
                click: this.handleClick,
            },
            props: ctx === null || ctx === void 0 ? void 0 : ctx.props,
        }, this.$slots.default);
    };
    __decorate([
        Prop({ default: 300 }),
        __metadata("design:type", Number)
    ], UiButton.prototype, "rippleDuration", void 0);
    __decorate([
        Prop({ default: 'button' }),
        __metadata("design:type", String)
    ], UiButton.prototype, "tag", void 0);
    UiButton = __decorate([
        Component
    ], UiButton);
    return UiButton;
}(Vue));
export default UiButton;
